import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6953cf8e66cdef001409b39a/cargotrack_pro/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6953cf8e66cdef001409b39a/cargotrack_pro/src/app/service-comparison/components/ServiceComparisonInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6953cf8e66cdef001409b39a/cargotrack_pro/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6953cf8e66cdef001409b39a/cargotrack_pro/src/components/ui/AppIcon.tsx");
